import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { IconChevron } from '../../icon/IconChevron';
import { Flex } from '../../layout/Flex';

const CHEVRON_SIZE = 20;

export const Chevron = styled(IconChevron).withConfig({ displayName: 'Chevron' }).attrs({
    size: CHEVRON_SIZE,
    color: 'var(--color-primary)',
})`
    transform: rotate(-90deg);
`;

export const ItemContainer = styled(Flex).withConfig({ displayName: 'ItemContainer' }).attrs({
    m: 'auto',
    pt: 2,
    direction: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    as: Link,
    textDecoration: 'none',
})``;
